import styled from 'styled-components';

export const InputLabel = styled.label`
  display: flex;
  flex-direction: column;
  margin: 3.5% 0;
  font-size: 1rem;
`;
